import request from "../../../utils/request";

// 列表
export const getRedeemList = (params) => {
  return request({
    method: "GET",
    path: "/admin-management/getRedeemList",
    params,
  });
};

// 核销操作
export const redeemVerify = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/redeemVerify",
    params,
  });
};

// 购买操作
export const buyGoods = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/buyGoods",
    params,
  });
};

// 发货操作
export const sendGoods = (params) => {
  return request({
    method: "POST",
    path: "/admin-management/sendGoods",
    params,
  });
};
